import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  movieContainer: {
    margin: 'auto',
    marginTop: '60px',
    overflow: 'auto',
    overflowX: 'hidden',
    height: '100%',
    '&::-webkit-scrollbar': {
      width: 0,
    },
    fontFamily: 'Roboto'
  },
  movieTitleGrid: {
    width: '100%',
  },
  movieAddButton: {
    color: '#fff',
    height: '30px',
    backgroundColor: '#3f51b5',
    float: 'right',
    cursor: 'pointer',
  },
  movieAddButtonSpan: {
    margin: '0px 5px 0px -4px',
    fontSize: '20px',
  },
  gridConteiner: {
    marginBottom: '140px',
  },
}));

export { useStyles };
